export default __webpack_public_path__ + "static/media/king_of_swords.17487be6.png";